import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";
import { ClientSelectedProgram } from "utils/Constant";
import { requiresProgramSelection } from "utils/permissions/permissions.helpers";
import { getCookieValue } from "utils/Storage";

const ProtectedRoute = ({
  component: Component,
  location,
  authUser,
  ...rest
}) => {
  // Check if user is authenticated
  if (!authUser) {
    return (
      <Route
        {...rest}
        render={() => (
          <Redirect
            to={{
              pathname: "/signin",
              state: { from: location },
            }}
          />
        )}
      />
    );
  }

  // Check if this user type needs program selection (only facility users)
  if (requiresProgramSelection(authUser)) {
    const currentProgram = getCookieValue(ClientSelectedProgram);

    // If facility user hasn't selected a program, redirect to program selection
    if (!currentProgram) {
      return (
        <Route
          {...rest}
          render={() => (
            <Redirect
              to={{
                pathname: "/select-program",
                state: { from: location },
              }}
            />
          )}
        />
      );
    }
  }

  // User is authenticated and has selected program if needed
  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

ProtectedRoute.propTypes = {
  component: PropTypes.func,
  location: PropTypes.object,
  authUser: PropTypes.object,
};

export default ProtectedRoute;
